
import { useEffect } from "react";

// Initialize animations once document is ready
export const initializeAnimations = () => {
  const animatedElements = document.querySelectorAll('[data-animation]');
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const animationClass = entry.target.getAttribute('data-animation');
        if (animationClass) {
          entry.target.classList.add(animationClass);
          observer.unobserve(entry.target);
        }
      }
    });
  }, {
    threshold: 0.1
  });
  
  animatedElements.forEach(element => {
    observer.observe(element);
  });
};

// Hook to initialize animations
export const useAnimations = () => {
  useEffect(() => {
    initializeAnimations();
  }, []);
};
